module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/172.98a7b0b1.png";